import React, {useState, useEffect} from 'react';
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { toast, ToastContainer } from "react-toastify";
import { sbaAxios } from '../../utils/sbaAxios';
import { SBAComboBox, SBADropDown, SBAMultiSelect } from '../../UiComponents/SBADropDown';
import { SBADrawer } from '../../UiComponents/SBADrawer';
import { AgGridReact } from 'ag-grid-react';
import { Modal } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import { 
    getCustodianSources,
    getCustodianAccounts,
    getCustodians,
    upsertCustodian,
    upsertCustodianAccount,
    getPortfolios,
    getCustodianAssets,
    deleteCustodian,
    deleteCustodianAccount
 } from '../../../config/apiConfig';

const Custodians = () => {
    const Level = [{ BreadCrumb: "Admin >", Routes: `${UrlPath.Admin}` }, {BreadCrumb:"Custodians", Routes:`${UrlPath.Custodians}`}];

    const [custodianSources, setCustodianSources] = useState([]);
    const [selectedCustodianSource, setSelectedCustodianSource] = useState(null);
    const [custodianAccounts, setCustodianAccounts] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerContent, setDrawerContent] = useState("");
    const [editParams, setEditParams] = useState(null);
    const [upsertDone, setUpsertDone] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const deleteModalTitle = "Delete Custodian Account";
    const prompt = "The selected Custodian Account will be deleted. Are you sure?";


    const removeDrawerTabIndex = () => {
        const drawers = document.getElementsByClassName('rs-drawer-wrapper');
        Array.from(drawers).forEach(drawer => {
          drawer.removeAttribute('tabIndex');
        });
    };
    removeDrawerTabIndex();

    const fetchCustodianAccounts = async() => {
        try{
            const list = await sbaAxios({
                url:getCustodianAccounts,
                params:{
                    custodianSourceId: selectedCustodianSource?.CustodianSourceId
                }
            });
            setCustodianAccounts(list);
        }
        catch(e){
            setCustodianAccounts([]);
        }
    };

    const fetchCustodianSources = async() => {
        try{
            const list = await sbaAxios({
                url:getCustodianSources
            });
            setCustodianSources(list);
        }
        catch(e){
            setCustodianSources([]);
        }
    };

    const handleAddCustodian = () => {
        setDrawerContent("Add Custodian");
        setDrawerOpen(true);
    };

    const handleAddCustodianAccount = () => {
        setDrawerContent("Add Custodian Account");
        setDrawerOpen(true);
        setEditParams(null);
        setUpsertDone(false);
    };

    const handleEditClick = (params) => {
      setEditParams({...params.data});
      setDrawerContent("Update Custodian Account");
      setDrawerOpen(true);
      setUpsertDone(false);
    };

    const handleDeleteCustodianAccount = async(id) => {
      try{
        const isDeleted = await sbaAxios({
          url: `${deleteCustodianAccount}/${id}`,
          method:'post'
        });
        if(isDeleted){
          toast.success("Custodian Account Deleted successfully");
        }
        else{
          toast.error("Unable to delete Custodian Account");
        }
      }
      catch(e){
        toast.error("Unable to delete Custodian Account");
      }
      fetchCustodianAccounts();
      setShowDeleteModal(false);
    };

    const handleDeleteClick = (params) => {
      setShowDeleteModal(true);
      setDeleteId(params?.data?.CustodianAccountId);
    };

    useEffect(() => {
        fetchCustodianSources();
    },[]);

    useEffect(() => {
      if(upsertDone && selectedCustodianSource){
        fetchCustodianAccounts();
      }
    }, [selectedCustodianSource, upsertDone]);

    useEffect(()=>{
        document.title="Custodians";
    },[]);

    const actionCellRenderer = (params) => {
        return (
          <div className="actions-cell">
            <i className="fas fa-edit" style={{ color:"#47A547", margin: "0 8px", cursor: "pointer" }} onClick={() => handleEditClick(params)}></i>
            <i className="fa fa-trash" style={{ color: "red" , margin: "0 8px", cursor: "pointer" }} onClick={() => handleDeleteClick(params)}></i>
          </div>
        );
      };

    const custAccColDefs = [
        {headerName:"Family", field:"FamilyName", flex: 0.2},
        {headerName:"Custodian", field:"CustodianName", flex: 0.4},
        {headerName:"Account Title", field:"AccountTitle",flex: 0.7},
        {headerName:"Portfolio", field:"PortfolioName", flex: 0.3},
        {headerName:"Asset", field:"AssetName", flex: 0.4},
        {headerName:"Action", field: "Action", cellRenderer: actionCellRenderer, flex: 0.2}
    ];

    return(
        <>
        <TopBar label={"Custodians"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level}/>
            <div className="container-fluid p-4">
            <div className="row">
                <div className="col-3">
                    <label className="label">Custodian Sources</label>
                    <div className="d-flex align-items-center">
                    <SBAComboBox
                        className="w-100"
                        data={custodianSources}
                        textField={"CustodianSourceName"}
                        valueField={"CustodianSourceId"}
                        value={selectedCustodianSource}
                        onChange={(e) => setSelectedCustodianSource(e.value)}
                        popupSettings={{ className: "modalDD" }}
                    />
                    <button className="p-sm-btn ms-2" onClick={fetchCustodianAccounts} disabled={!selectedCustodianSource}>Go</button>
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="d-flex justify-content-end gap-2">
                    <button className='p-sm-btn mb-2' onClick={handleAddCustodian}>Add Custodian</button>
                    <button className='p-sm-btn mb-2' onClick={handleAddCustodianAccount}>Add Account</button>
                </div>
                </div>
                <div className="row mt-2">
                    <div
                        className="ag-theme-alpine"
                        style={{ height: "500px", width: "100%", paddingTop: 0 }}
                    >
                        <AgGridReact
                            rowData={custodianAccounts}
                            columnDefs={custAccColDefs}
                            defaultColDef={{ resizable: true, sortable: true, filter: true ,flex:1}}
                        />
                    </div>
                </div>
            </div>
        </div>
        <SBADrawer open={drawerOpen} setOpen={setDrawerOpen} title={drawerContent} style={{ width: "40vw" }}>
            {
                drawerContent === "Add Custodian" &&
                <AddOrEditCustodian
                    custSources={custodianSources}
                    setDrawerOpen={setDrawerOpen}
                />
            }
            {
                ((drawerContent === "Add Custodian Account") || (drawerContent === "Update Custodian Account") ) &&
                <AddOrEditCustodianAccount
                    custSources={custodianSources}
                    setDrawerOpen={setDrawerOpen}
                    editParams={editParams}
                    setUpsertDone={setUpsertDone}
                />
            }
        </SBADrawer>
        <DeleteModal
          showModal={showDeleteModal}
          setShowModal={setShowDeleteModal}
          modalTitle={deleteModalTitle}
          deleteId={deleteId}
          prompt={prompt}
          handleDelete={handleDeleteCustodianAccount}
        />
        <ToastContainer/>
    </>
    );
};

const AddOrEditCustodian = ({custSources, setDrawerOpen}) => {
    const [selectedCustodianSource, setSelectedCustodianSource] = useState(null);
    const [custodians, setCustodians] = useState([]);
    const [selectedCustodian, setSelectedCustodian] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [mode, setMode] = useState("");
    const [inputLabel, setInputLabel] = useState("");
    const [custodianName, setCustodianName] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const deleteModalTitle = "Delete Custodian";
    const prompt = "The selected Custodian will be deleted. Are you sure?";

    const removeDrawerTabIndex = () => {
        const drawers = document.getElementsByClassName('rs-drawer-wrapper');
        Array.from(drawers).forEach(drawer => {
          drawer.removeAttribute('tabIndex');
        });
    };
    removeDrawerTabIndex();

    const fetchCustodians = async() => {
        try{
            const list = await sbaAxios({
                url:getCustodians,
                params:{
                    custodianSourceId: selectedCustodianSource?.CustodianSourceId
                }
            });
            setCustodians(list);
        }
        catch(e){
            setCustodians([]);
        }
    };

    useEffect(() => {
        if(selectedCustodianSource?.CustodianSourceId){
            fetchCustodians();
        }
    },[selectedCustodianSource]);

    const handleStateReset = () => {
        fetchCustodians();
        setShowModal(false);
        setSelectedCustodian(null);
        setMode("");
        setInputLabel("");
        setCustodianName("");
        setModalTitle("");
    };

    const handleAddClick = () => {
        if(!selectedCustodianSource){
            toast.error('Select a Custodian Source');
            return;
        }
        setModalTitle("Add Custodian");
        setMode("Add");
        setInputLabel("Custodian Name");
        setCustodianName("");
        setShowModal(true);
    };

    const handleEditClick = () => {
        if(!selectedCustodianSource){
            toast.error('Select a Custodian Source');
            return;
        }
        if(!selectedCustodian){
            toast.error('Select a Custodian.');
            return;
        }
        setModalTitle("Update Custodian");
        setMode("Update");
        setInputLabel("Custodian Name");
        setCustodianName(selectedCustodian?.CustodianName);
        setShowModal(true);
    };

    const handleCustodianDelete = async(id) => {
      try{
        const isDeleted = await sbaAxios({
          url: `${deleteCustodian}/${id}`,
          method: 'post'
        });
        if(isDeleted){
          toast.success("Custodian Deleted successfully");
        }
        else{
          toast.error("Unable to delete Custodian");
        }
      }
      catch(e){
        toast.error("Unable to delete Custodian");
      }
      setSelectedCustodian(null);
      setShowDeleteModal(false);
      fetchCustodians();
    };

    const handleDeleteClick = () => {
      if(!selectedCustodian){
        toast.error("Please Select a Custodian");
        return;
      }
      setShowDeleteModal(true);
      setDeleteId(selectedCustodian?.CustodianId);
    };

    const handleUpsert = async(upsertMode) => {
        const postData = {
            custodianId: upsertMode === "Add" ? 0 : selectedCustodian?.CustodianId,
            custodianName: custodianName,
            custodianSourceId: selectedCustodianSource?.CustodianSourceId,
            isActive: true
        };
        if(!selectedCustodianSource){
            toast.error('Please Select a Source!');
        }
        else{
            if(custodianName === "" || custodianName === null){
                toast.error('Please Enter a Custodian Name.');
            }
            else{
                try{
                    await sbaAxios({
                        url:upsertCustodian,
                        method:'post',
                        data: postData
                    });
                    toast.success(`Custodian ${upsertMode === "Add" ? "Added" : "Updated"} successfully.`);
                    handleStateReset();
                }
                catch(e){
                    toast.error(`Unable to ${upsertMode === "Add" ? "Add" : "Update"} Custodian.`);
                    handleStateReset();
                }
            }
        }
    };

    return (
      <>
        <div className="row">
          <div className="col-6">
            <label className="label">Sources</label>
            <div className="d-flex align-items-center">
              <SBAComboBox
                className="w-100"
                data={custSources}
                textField={"CustodianSourceName"}
                valueField={"CustodianSourceId"}
                value={selectedCustodianSource}
                onChange={(e) => setSelectedCustodianSource(e.value)}
                popupSettings={{ className: "modalDD" }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-6">
            <label className="label">Custodians</label>
            <div className="d-flex align-items-center">
              <SBAComboBox
                className="w-100"
                data={custodians}
                textField={"CustodianName"}
                valueField={"CustodianId"}
                value={selectedCustodian}
                onChange={(e) => setSelectedCustodian(e.value)}
                popupSettings={{ className: "modalDD" }}
              />
            </div>
          </div>
          <div className='col align-content-end'>
            <div className='d-flex align-content-center'>
            <i
                className="fas fa-add"
                style={{
                  color: "#47A547",
                  margin: "0 8px",
                  cursor: "pointer",
                  height: "20px",
                }}
                onClick={handleAddClick}
              ></i>
              <i
                className="fas fa-edit"
                style={{
                  color: "#47A547",
                  margin: "0 8px",
                  cursor: "pointer",
                  height: "20px",
                }}
                onClick={handleEditClick}
              ></i>
              <i
                className="fas fa-trash"
                style={{
                  color: "#FA0000",
                  margin: "0 8px",
                  cursor: "pointer",
                  height: "20px",
                }}
                onClick={handleDeleteClick}
              ></i>
            </div>
          </div>
        </div>
        <AddOrEditModal 
            showModal={showModal} 
            setShowModal={setShowModal} 
            modalTitle={modalTitle}
            mode={mode}
            inputLabel={inputLabel}
            inputText={custodianName}
            setInputText={setCustodianName}
            handleUpsert={handleUpsert}
        />
        <DeleteModal
          showModal={showDeleteModal}
          setShowModal={setShowDeleteModal}
          modalTitle={deleteModalTitle}
          deleteId={deleteId}
          prompt={prompt}
          handleDelete={handleCustodianDelete}
        />
      </>
    );
};

const AddOrEditCustodianAccount = ({custSources, setDrawerOpen, editParams, setUpsertDone}) => {
    const [selectedCustodianSource, setSelectedCustodianSource] = useState(null);
    const [custodians, setCustodians] = useState([]);
    const [selectedCustodian, setSelectedCustodian] = useState(null);
    const [portfolios, setPortfolios] = useState([]);
    const [selectedPortfolio, setSelectedPortfolio] = useState(null);
    const [assets, setAssets] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [upsertMode, setUpsertMode] = useState("Add");
    const [accountName, setAccountName] = useState("");
    const [accountId, setAccountId] = useState(0);

    const fetchCustodians = async() => {
        try{
            const list = await sbaAxios({
                url:getCustodians,
                params:{
                    custodianSourceId: selectedCustodianSource?.CustodianSourceId
                }
            });
            setCustodians(list);
        }
        catch(e){
            setCustodians([]);
        }
    };

    const fetchPortfolios = async() => {
        try{
            const list = await sbaAxios({
                url:getPortfolios,
            });
            setPortfolios(list);
        }
        catch(e){
            setPortfolios([]);
        }
    };

    const fetchAssets = async() => {
        try{
            const list = await sbaAxios({
                url:`${getCustodianAssets}/${selectedPortfolio?.PortfolioId}`
            });
            const sortedList = list.sort((a, b) => a.AssetName.localeCompare(b.AssetName))
            setAssets(sortedList);
        }
        catch(e){
            setAssets([]);
        }
    };

    const populateSource = (edParams) => {
      const foundCustodianSource = custSources.find((item) => item.CustodianSourceId === edParams?.CustodianSourceId);
      setSelectedCustodianSource(foundCustodianSource);
      setAccountName(edParams?.AccountTitle);
      setAccountId(edParams?.CustodianAccountId);
    };

    useEffect(() => {
        fetchPortfolios();
    }, []);

    useEffect(() => {
        if(selectedPortfolio?.PortfolioId){
            fetchAssets();
        };
    }, [selectedPortfolio]);

    useEffect(() => {
        if(selectedCustodianSource?.CustodianSourceId){
            fetchCustodians();
        }
    },[selectedCustodianSource]);

    useEffect(() => {
      if(editParams){
        populateSource(editParams);
        setUpsertMode("Update");
      }
      else{
        setUpsertMode("Add");
        setCustodians([]);
        setSelectedCustodian(null);
        setSelectedPortfolio(null);
        setAssets([]);
        setSelectedAsset(null);
      }
    }, [editParams]);

    useEffect(() => {
      if (custodians.length > 0 && editParams) {
        const foundCustodian = custodians.find((item) => item.CustodianId === editParams?.CustodianId) || null;
        setSelectedCustodian(foundCustodian);
      }
    }, [custodians, editParams]);

    useEffect(() => {
      if (portfolios.length > 0 && editParams) {
        const foundPortfolio = portfolios.find((item) => item.PortfolioId === editParams?.PortfolioId) || null;
        setSelectedPortfolio(foundPortfolio);
      }
    }, [portfolios, editParams]);
    
    useEffect(() => {
      if (assets.length > 0 && editParams) {
        const foundAsset = assets.find((item) => item.AssetId === editParams?.AssetId) || null;
        setSelectedAsset(foundAsset);
      }
    }, [assets, editParams]);

    const handleUpsert = async() => {
        if(accountName === "" || accountName === null){
            toast.error('Please Enter a Custodian Account Name.');
        }
        else{
            if(!selectedCustodianSource){
              toast.error('Please Select a Source!');
              return;
            }
            if(!selectedCustodian){
                toast.error('Please Select a Custodian.');
                return;
            }
            if(!selectedPortfolio){
                toast.error('Please Select a Portfolio.');
                return;
            }
            if(!selectedAsset){
                toast.error('Please Select an Asset');
                return;
            }
            try{
                const postData = {
                    custodianAccountId: upsertMode === "Add" ? 0 : accountId,
                    custodianSourceId: selectedCustodianSource?.CustodianSourceId,
                    custodianId: selectedCustodian?.CustodianId,
                    accountTitle: accountName,
                    portfolioId: selectedPortfolio.PortfolioId,
                    assetId: selectedAsset.AssetId,
                    isActive: true
                };
                await sbaAxios({
                    url:upsertCustodianAccount,
                    method:'post',
                    data: postData
                });
                toast.success(`Custodian Account ${upsertMode === "Add" ? "Added" : "Updated"} successfully.`);
                setDrawerOpen(false);
                setUpsertDone(true);
            }
            catch(e){
                toast.error(`Unable to ${upsertMode === "Add" ? "Add" : "Update"} Custodian Account.`);
                setDrawerOpen(false);
                setUpsertDone(false);
            }
        }
    };

    return(
        <>
        <div className="row">
          <div className="col-6">
            <label className="label">Account Name</label>
            <div className="d-flex align-items-center">
              <input
                className="w-100 input-default form-control"
                value={accountName}
                onChange={(e) => setAccountName(e.target.value)}
                popupSettings={{ className: "modalDD" }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-6">
            <label className="label">Sources</label>
            <div className="d-flex align-items-center">
              <SBAComboBox
                className="w-100"
                data={custSources}
                textField={"CustodianSourceName"}
                valueField={"CustodianSourceId"}
                value={selectedCustodianSource}
                onChange={(e) => setSelectedCustodianSource(e.value)}
                popupSettings={{ className: "modalDD" }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-6">
            <label className="label">Custodians</label>
            <div className="d-flex align-items-center">
              <SBAComboBox
                className="w-100"
                data={custodians}
                textField={"CustodianName"}
                valueField={"CustodianId"}
                value={selectedCustodian}
                onChange={(e) => setSelectedCustodian(e.value)}
                popupSettings={{ className: "modalDD" }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-6">
            <label className="label">Portfolios</label>
            <div className="d-flex align-items-center">
              <SBAComboBox
                className="w-100"
                data={portfolios}
                textField={"Name"}
                valueField={"PortfolioId"}
                value={selectedPortfolio}
                onChange={(e) => {
                  setSelectedPortfolio(e.value);
                  setSelectedAsset(null);
                }}
                popupSettings={{ className: "modalDD" }}
              />
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-6">
            <label className="label">Assets</label>
            <div className="d-flex align-items-center">
              <SBAComboBox
                className="w-100"
                data={assets}
                textField={"AssetName"}
                valueField={"AssetId"}
                value={selectedAsset}
                onChange={(e) => setSelectedAsset(e.value)}
                popupSettings={{ className: "modalDD" }}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end gap-2 mt-3">
          <button className="p-sm-btn mx-1" onClick={handleUpsert}>
            {upsertMode === "Add" ? "Save" : "Update"}
          </button>
          <button className="s-sm-btn mx-1" onClick={()=>setDrawerOpen(false)}>
            Cancel
          </button>
        </div>
        </>
    );
};

const AddOrEditModal = ({showModal, setShowModal, modalTitle, mode, inputLabel, inputText, setInputText, handleUpsert}) => {
    return (
      <Modal show={showModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setShowModal(false);
          }}
        >
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-6">
              <label>{inputLabel}</label>
              <Form>
                <Form.Group className="mb-4">
                  <Form.Control
                    className="form-control w-100"
                    type="text"
                    value={inputText}
                    onChange={(e) => {
                      setInputText(e.target.value);
                    }}
                    autoFocus
                  />
                </Form.Group>
              </Form>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="s-sm-btn mx-1" onClick={() => {setShowModal(false)}}>
            Cancel
          </button>
          <button className="p-sm-btn mx-1" onClick={() => handleUpsert(mode)}>
            {mode}
          </button>
        </Modal.Footer>
      </Modal>
    );
};

const DeleteModal = ({showModal, setShowModal, modalTitle, deleteId, prompt, handleDelete}) => {
  return (
    <Modal show={showModal}>
      <Modal.Header
        closeButton
        onClick={() => {
          setShowModal(false);
        }}
      >
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          {prompt}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="s-sm-btn mx-1" onClick={() => {setShowModal(false)}}>
          Cancel
        </button>
        <button className="p-sm-btn mx-1" onClick={() => handleDelete(deleteId)}>
          Delete
        </button>
      </Modal.Footer>
    </Modal>
  );
};


export default Custodians;